import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { setOptions, bootstrap } from "vue-gtag";
import ApiSites from "@/services/sites.js";
import createPersistedState from "vuex-persistedstate";
import checkout from "./modules/checkout";
import * as CheckoutMutations from "@/store/modules/checkout/mutation-types";
import ActionTypes from "@/constants/action-types.js";

Vue.use(Vuex);

const checkoutState = createPersistedState({
  paths: ["checkout"]
});

export default new Vuex.Store({
  state: {
    filters: [],
    items: [],
    searchTerm: "",
    selectedCategory: null,
    config: {},
    loading: true,
    showInstallMessage: false
  },
  actions: {
    async setConfig({ commit, dispatch }, data) {
      try {
        commit("SET_LOADING", true);
        const _uid = data?.uid;
        const _websiteId = data?.websiteId;
        const isWidget = process.env.VUE_APP_MODE === "widget";
        let websiteId = "";

        if (isWidget) {
          Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_URL;
          Vue.prototype.$http.defaults.headers.common["x-uid"] = _uid;
          websiteId = _websiteId;
        } else {
          const data = await fetch("./config.json");
          const localConfig = await data.json();
          Vue.prototype.$http.defaults.baseURL = localConfig.apiUrl;
          Vue.prototype.$http.defaults.headers.common["x-uid"] =
            localConfig.uid;
          websiteId = localConfig.websiteId;
        }

        const config = (await ApiSites.config({ websiteId })).data;
        commit("SET_CONFIG", config.website);
        if (config.website.isPro && config.website.gaId) {
          setOptions({
            config: {
              id: config.website.gaId,
              params: {
                send_page_view: true
              }
            }
          });
          bootstrap().then(_ => {});
        }
        commit("SET_LOADING", false);

        commit(
          `checkout/${CheckoutMutations.SHOW_PRODUCT_OPTIONS_MODAL}`,
          false,
          { root: true }
        );

        dispatch("setPwaConfig");
        const { website } = config;
        if (website.theme && website.theme.font && website.theme.font.cdn) {
          const {
            theme: { font }
          } = website;
          console.log(font);
          const fileref = document.createElement("link");
          fileref.rel = "stylesheet";
          fileref.type = "text/css";
          fileref.href = font.cdn;
          document.getElementsByTagName("head")[0].appendChild(fileref);
          document.getElementById("app").style.fontFamily = `'${font.name}'`;
          // document.body.style.fontFamily = `'${font.name}'`;
        } else {
          document.getElementById("app").style.fontFamily =
            "'Roboto', sans-serif";
        }
      } catch (error) {
        console.log(error);
      }
    },

    async setPwaConfig({ commit, state }) {
      // Detects if device is on iOS
      const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
      };

      // Detects if device is in standalone mode
      const isInStandaloneMode = () =>
        "standalone" in window.navigator && window.navigator.standalone;

      // Checks if should display install popup notification:
      if (isIos() && !isInStandaloneMode() && state.config?.pwa?.active) {
        commit("SET_SHOW_INSTALL_MESSAGE", true);
      }
    },

    async getItems({ commit, state }) {
      try {
        const params = { filterBy: state.config?.listView?.filterBy?.name };
        const sheetName = state?.config?.sheet?.sheet;

        if (sheetName) {
          params.sheetName = sheetName;
        }

        if (state.config?.sheet?.id) {
          const res = await axios.get(
            `api/sheets/${state.config.sheet.id}/items`,
            {
              params
            }
          );
          commit("setItems", res.data.items);
          commit("setFilters", res.data.filters);
        } else {
          commit("setItems", []);
          commit("setFilters", []);
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mutations: {
    setItems(state, value) {
      state.items = value;
    },
    setFilters(state, value) {
      state.filters = value;
    },
    setSearchTerm(state, value) {
      state.searchTerm = value;
    },
    setSelectedCategory(state, value) {
      state.selectedCategory = value;
    },
    ["SET_CONFIG"](state, config) {
      state.config = config;
    },
    ["SET_LOADING"](state, loading) {
      state.loading = loading;
    },
    ["SET_SHOW_INSTALL_MESSAGE"](state, show) {
      state.showInstallMessage = show;
    }
  },
  getters: {
    isCheckoutEnabledInListView(state) {
      return state.config.listView?.cta?.type === ActionTypes.NUM_CHECKOUT;
    },
    isCheckoutEnabledInDetailView(state) {
      return state.config.detailView?.cta?.type === ActionTypes.NUM_CHECKOUT;
    },
    isShoppingCartEnabled(_, getters) {
      return (
        getters.isCheckoutEnabledInListView &&
        getters.isCheckoutEnabledInDetailView
      );
    }
  },
  modules: {
    checkout
  },
  plugins: [checkoutState]
});
